const VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_.\-\d]*$/;
const nameCache = {};
export function isValidTagOrAttributeName(tagName) {
    if (!(tagName in nameCache)) {
        nameCache[tagName] = VALID_TAG_REGEX.test(tagName);
    }
    return nameCache[tagName];
}
//# sourceMappingURL=isValidTagOrAttributeName.js.map